import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CampaignFinance, CampaignFinanceData } from "../data/campaignFinance";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";

@Injectable()
export class CampaignFinanceService extends CampaignFinanceData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiCampaign: string;
  header: any;
  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }

  async createCampaignFinance(data) {
    try {
      let response = await this.http
        .post(this.api + "finance/campaigns", data)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getCampaignsFinance(pagination, filter, order) {
    console.log({ pagination, filter, order });1
    try {
      let response = await this.http
        .post(this.api + "finance/campaigns", { pagination, filter, order })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getCampaignFinance(id: string) {
    try {
      let Campaign = <CampaignFinance>(
        await this.http.get(this.api + "finance/campaign/" + id).toPromise()
      );
      return Campaign;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async editCampaignFinance(data, id?: string) {
    try {
      let response = <CampaignFinance>(
        await this.http
          .put(this.api + "finance/campaign/" + (id || ""), data)
          .toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async deleteCampaignFinance(id?: string) {
    try {
      let response = <CampaignFinance>(
        await this.http.delete(this.api + "finance/campaign/" + id).toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async exportCampaignFinanceId(dateStart: any, dateEnd: any, id: any) {
    try {
      let response = await this.http
        .post(this.api + "finance/campaign/export/" + id, { dateStart, dateEnd })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async getPresetsFinance(id: string) {
    try {
      let Campaign = <CampaignFinance>(
        await this.http.get(this.api + "campaign/preset/" + id).toPromise()
      );
      return Campaign;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async createPresetFinance(data) {
    try {
      let response = await this.http
        .post(this.api + "preset", data)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

}
